import { z } from 'zod/v4';

import { styleBagSchema } from '../../../common/schemas/legacy';

import { menuLegacyDataSchema } from './data';

/**
 * Legacy `menu` widget envelope — its only placement (`params.type: ['default']`, drop anywhere).
 * No `type` discriminator, same reasoning as indent/logo/navigation.
 */
export const menuLegacyDefaultV0Schema = z.object({
    id: z.string(),
    name: z.literal('menu'),
    columnId: z.string(),
    structureId: z.string().nullish(),
    displayId: z.string().nullish(),
    data: menuLegacyDataSchema,
    styles: styleBagSchema.nullish(),
    mobileStyles: styleBagSchema.nullish(),
});
